import * as React from 'react';
import { Checkbox } from 'semantic-ui-react';
import styles from './GenerateCheckboxes.module.scss';

interface ICheckBoxComponentProps {
    item: any;
    title: string;
    isChecked: boolean;
}

interface ICheckBoxComponentState {
    isChecked: boolean;
    checkboxClass:  string;
}

export class CheckBoxComponent extends React.Component<ICheckBoxComponentProps, ICheckBoxComponentState> {

    constructor(props: ICheckBoxComponentProps) {
        super(props);

        this.state = ({
            isChecked: this.props.isChecked,
            checkboxClass: this.props.isChecked ? styles.checkboxesCheck : styles.checkboxes
        });
    }

    public render() {
        return (
            <Checkbox label={this.props.item} className={this.state.checkboxClass} checked={this.state.isChecked}  onChange={this.checkboxHandle.bind(this)} onClick={(e) => this.onClickHandler()} />
        );

    }

    private checkboxHandle() {
        let isChecked = !this.state.isChecked;

        this.setState({
            isChecked: isChecked,
            checkboxClass: isChecked ? styles.checkboxesCheck : styles.checkboxes
        });
    }

    private onClickHandler() {
        if (this.props.title == 'Division') {
            var division: string[] = JSON.parse(localStorage.getItem('division') || '');
            
            if (this.state.isChecked) {
                var divisionIndex = division.indexOf(this.props.item);
                if (divisionIndex !== -1) {
                division.splice(divisionIndex, 1);
                }
            } else {
                division.push(this.props.item)
            }

            localStorage.setItem("division", JSON.stringify(division));           
        }

        if (this.props.title == 'Document Type') {
            var documentType: string[] = JSON.parse(localStorage.getItem('documentType') || '');
            
            if (this.state.isChecked) {
                var documentTypeIndex = documentType.indexOf(this.props.item);
                if (documentTypeIndex !== -1) {
                    documentType.splice(documentTypeIndex, 1);
                }
            } else {
                documentType.push(this.props.item)
            }

            localStorage.setItem("documentType", JSON.stringify(documentType));           
        }
    }
}